import _Model from "./_Model";

export default class PacConsumptionBlock extends _Model {
  constructor(json) {
    super(json);
    this.consumption3Dot3V = PacConsumptionBlock.getOrDefault(json, 'consumption3Dot3V', 0);
    this.consumption24V = PacConsumptionBlock.getOrDefault(json, 'consumption24V', 0);
    this.consumption24VSensors = PacConsumptionBlock.getOrDefault(json, 'consumption24VSensors', 0);
    this.maxComsumption3Dot3and24V = PacConsumptionBlock.getOrDefault(json, 'maxComsumption3Dot3and24V', 0);
    this.maxConsumption3Dot3V = PacConsumptionBlock.getOrDefault(json, 'maxConsumption3Dot3V', 0);
    this.maxConsumption24V = PacConsumptionBlock.getOrDefault(json, 'maxConsumption24V', 0);
    this.maxConsumption24VSensors = PacConsumptionBlock.getOrDefault(json, 'maxConsumption24VSensors', 0);
    this.maxGlobalConsumption = PacConsumptionBlock.getOrDefault(json, 'maxGlobalConsumption', 0);
  }
}
